import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { residences } from "../services/soar";
import ResidenceBeds from "./ResidenceBeds";

function ResidenceProgramHome(props) {
  const params = useParams();
  const [residenceData, setResidenceData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [updateData, setUpdateData] = useState(false);
  const applicationId =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
      : "58990f83-8566-4ba8-b4b5-584a64e4cba1";

  useEffect(() => {
    getResidenceData();
  }, []);

  useEffect(() => {
    if (updateData) {
      getResidenceData();
      setUpdateData(false);
    }
  }, [updateData]);

  const getResidenceData = async () => {
    const body = {
      command: "query",
      application: applicationId,
      keyword: "byid",
      ids: [params.id],
    };
    const data = await residences(body);
    setResidenceData(data.data[0]);
  };

  const handleActivateDeactivate = async () => {
    const body = {
      command: residenceData.active ? "deactivate" : "reactivate",
      application: applicationId,
      id: residenceData.id,
      modifiedBy: JSON.parse(localStorage.getItem("safyInfo")).user.azureId,
    };
    const response = await residences(body);
    if (response.code === "success") {
      setResidenceData({ ...residenceData, active: !residenceData.active });
      toast.success(`${residenceData.active ? "Deactivated" : "Activated"}`);
    } else {
      toast.error("Error updating apartment status");
    }
  };

  return (
    <>
      <div
        className={residenceData.active === false ? "bg-warning p-2" : "p-2"}
      >
        <div>
          <div className="row">
            <div className="col-10 h3">{residenceData.name}</div>
            <div className="col-2 ">
              <i
                className="fas fa-pen rounded border border-dark bg-primary text-white p-2 ms-2 float-end"
                onClick={() => setShowModal(!showModal)}
              />
              <i
                className={`fas ${
                  residenceData.active
                    ? "fa-trash bg-danger"
                    : "fa-trash-can-arrow-up bg-success"
                } rounded border border-dark text-white p-2 ms-2 float-end`}
                role="button"
                onClick={handleActivateDeactivate}
              />
            </div>
          </div>
          <ResidenceBeds
            data={residenceData}
            setData={setResidenceData}
            updateData={() => setUpdateData(true)}
          />
        </div>
      </div>
    </>
  );
}

export default ResidenceProgramHome;
